/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner } from './get-purchase-application-templates200-response-inner-template-overview-approvers-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy } from './get-purchase-application-templates200-response-inner-template-overview-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy } from './get-purchase-application-templates200-response-inner-template-overview-submitted-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount } from './get-purchase-application-templates200-response-inner-template-overview-user-account';

/**
 * 
 * @export
 * @interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
 */
export interface GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview {
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'purchaseTemplateNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'templateId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'templateName': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'scopeDisclosure': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'templateCategory': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'templateDetail': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'submittedBy': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewSubmittedBy;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'purposeOfUse': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'amount': number | null;
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'userAccount': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewUserAccount | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'isOnDemandCard': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'remarks': string;
    /**
     * 
     * @type {GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'createdBy': GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewCreatedBy;
    /**
     * 
     * @type {Array<GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner>}
     * @memberof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverview
     */
    'approvers': Array<GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewApproversInner>;
}

export const GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum = {
    public: 'PUBLIC',
    individual: 'INDIVIDUAL'
} as const;

export type GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum = typeof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum[keyof typeof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewScopeDisclosureEnum];
export const GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum = typeof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum[keyof typeof GetPurchaseApplicationTemplates200ResponseInnerTemplateOverviewPurposeOfUseEnum];


